<app-announcer></app-announcer>
<app-skip-link
  linkId="skipLink"
  label="Skip to main content"
  [href]="skipLink"
></app-skip-link>
@if(inProgress$ | async) {
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
} @if(settings$ | async) {
<router-outlet></router-outlet>
} @else if (error()) {
<div class="app-maintenance">
  <h1>{{ "Maintenance" | translate }}</h1>
</div>
}
